import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { GridFilterModel, GridSortModel } from '@mui/x-data-grid';
import { DIAM_API_PATH, DiamPageSortField, getTeamsPage } from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';
import { buildTeamsPageFilter, toDiamSortFields } from '../../diamGridUtils';

export const TEAMS_LIST_FILTER = {};

export interface UseTeamsPageParams {
  page: number;
  pageSize: number;
  sortModel: GridSortModel;
  filterModel: GridFilterModel;
}

const DEFAULT_SORT: DiamPageSortField[] = [
  { field: 'createdDate', direction: 'DESC' },
];

export function useTeams({
  page,
  pageSize,
  sortModel,
  filterModel,
}: UseTeamsPageParams) {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials(DIAM_API_PATH);
  const filter = buildTeamsPageFilter(filterModel);
  const sort = toDiamSortFields(sortModel, DEFAULT_SORT);

  return useQuery({
    queryKey: ['diam', 'teams', 'page', page, pageSize, sort, filter] as const,
    queryFn: async () => {
      const idToken = await getIdToken();
      return getTeamsPage(apiUrl, idToken, {
        page,
        limit: pageSize,
        sort,
        filter,
      });
    },
    enabled: isSignedIn,
    placeholderData: keepPreviousData,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
